import styles from './menu.less'; export {styles};
import AbstractMenu, {MenuLinkData, MenuLinks} from '../shared/menu';
import Links from './menu/links';

interface MenuState {
    catalogLinks?: MenuLinkData[];
}

export default class Menu extends AbstractMenu<{}, MenuState> {

    menuRef = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props);

        this.state = {catalogLinks: null};
    }

    componentDidMount() {
        $j(window).on('load', () => {
            let loadLinks = this.props.onLoadCatalogLinks();
            if (loadLinks) {
                loadLinks.done(() => {
                    this.props.onUpdateCatalogLinks();
                });
            }
        });
    }

    componentDidUpdate(prevProps: Readonly<MenuLinks>, prevState: Readonly<MenuState>, snapshot?: any) {
        if (prevProps.catalogLinks !== this.props.catalogLinks) {
            this.trimCatalogLinks();
        }
    }

    trimCatalogLinks() {
        let maxTopLinks = 0;
        let menuWidth = $j(this.menuRef.current).outerWidth() - $j('.' + styles.other, this.menuRef.current).outerWidth();
        let linksWidth = 0;

        $j('.' + styles.catalog + ' > li', this.menuRef.current).each(function(idx) {
            let linkWidth = $j(this).outerWidth();

            if (linkWidth + linksWidth >= menuWidth) {
                maxTopLinks = idx - 1;
                return false;
            }

            linksWidth += linkWidth;
        });

        if (!maxTopLinks) {
            return;
        }

        let catalogLinks = this.props.catalogLinks;
        let trimmedLinks = catalogLinks.splice(maxTopLinks);

        catalogLinks.push({
            id: -1,
            name: _('Others'),
            url: '#',
            children: trimmedLinks
        });

        this.setState(Object.assign(this.state, {catalogLinks: catalogLinks}));
    }

    render() {
        return (
            <div className="nav container">
                <div className="inner-container">
                    <div className={styles.menu} ref={this.menuRef}>
                        <Links
                            currentCategoryIds={this.props.currentCategoryIds}
                            className={styles.catalog}
                            children={this.state.catalogLinks ? this.state.catalogLinks : this.props.catalogLinks}
                            level={0}
                            key={0}
                        />
                        <Links
                            className={styles.other}
                            children={this.props.otherLinks}
                            level={0}
                            key={1}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
